import { BRAND_NAME } from '../config/brand'

interface LogoProps {
  /** 'xl' for page headings, 'lg' for the sidebar header, 'md' for the compact mobile bar. */
  size?: 'md' | 'lg' | 'xl'
  /**
   * 'auto' follows the page theme (dark text when light, white under the
   * terminal theme); 'dark' is always white, for surfaces that are dark
   * regardless of theme, like the sign-in card.
   */
  tone?: 'auto' | 'dark'
  className?: string
}

// The name stays whole in the brand config; the wordmark just splits it at
// "Creator" so that half can be tinted. If the brand is ever renamed to
// something without that suffix, the whole name renders in the foreground.
const CREATOR_AT = BRAND_NAME.toLowerCase().lastIndexOf('creator')
const HEAD = CREATOR_AT > 0 ? BRAND_NAME.slice(0, CREATOR_AT) : BRAND_NAME
const TAIL = CREATOR_AT > 0 ? BRAND_NAME.slice(CREATOR_AT) : ''

/**
 * The wordmark. Every rendering of the brand name as a logo goes through here,
 * so the two-tone split ("Fin" in the foreground, "Creator" in the accent blue)
 * applies in the sidebar and the top bar alike -- but never to plain body-text
 * mentions of the name.
 */
const SIZE_CLASS = { md: 'text-xl', lg: 'text-2xl', xl: 'text-3xl' } as const

const Logo = ({ size = 'lg', tone = 'auto', className = '' }: LogoProps) => (
  <span
    className={`font-bold ${tone === 'dark' ? 'text-white' : 'text-gray-900 dark:text-gray-50'} ${SIZE_CLASS[size]} ${className}`}
    data-testid="logo"
  >
    {HEAD}
    {TAIL && <span className="text-accent">{TAIL}</span>}
  </span>
)

export default Logo
